import React from 'react'
import UseScrollReveal from '../Common/UseScrollReveal '

const HomeAbout = () => {
    UseScrollReveal();
    return (
        <>
            <section className='about-wrap'>
                <div className='container'>
                    <h2 className='main-title mb-3 reveal wow fadeIn'>The <span>McLaren Orlando</span> Difference</h2>
                    <p className='reveal wow fadeIn'>We are proud to be awarded the 2024 Global Retailer of the Year. Our team is committed to providing the premier destination for supercar enthusiasts. We strive to deliver unparalleled service, and a world class experience for those who share the passion for elite sports cars.</p>

                    <p className='reveal wow fadeIn'>Come see our unique collection, including new and pre-owned vehicles. All are passed and inspected by our world class factory-trained technicians. Want to build a completely unique McLaren? Ask about our personalized customization options through McLaren Special Operations.</p>
                </div>
            </section>
        </>
    )
}

export default HomeAbout